import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7669dd97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "platform-goods rel" }
const _hoisted_2 = { class: "abs platform-goods-search" }
const _hoisted_3 = { class: "api-goods-title" }
const _hoisted_4 = { class: "title flex-ter" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { style: {"max-width":"284px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/question_icon.png",
  class: "question-icon"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "platform-goods-item",
  style: {"flex":"1"}
}

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import Search from '../Search.vue'
import PlatformGoodsItem from './PlatformGoodsItem.vue'
import PlatformGoodsDrawer from './PlatformGoodsDrawer.vue'
import { isEN, isJA, isKO } from '@/store'
import { useStore } from 'vuex'
import { isUrl } from '@/plugins/utils'
import { searchProducts, searchUrl, searchUpload } from '@/apis/search'


export default /*#__PURE__*/_defineComponent({
  props: ['productList', 'change', 'add', 'height', 'keyIndex', 'shopDetail'],
  setup(__props) {

const props = __props

const keyword = ref('')
const langType = ref('')
const store = useStore()
const platformGoodsDrawer = ref()
const loading = ref(false)
const model = store.getters['bussiness/model']
langType.value = model.langType
const search = async (type: string, isSearch?: boolean, isComponentSearch?: boolean) => {
  if (loading.value) return
  loading.value = true
  // 链接或者sku需要提前请求接口
  if (isComponentSearch && keyword.value) {
    if (isUrl(keyword.value)) {
      const detail: any = await searchUrl({
        detailUrl: keyword.value
      })
      if (detail.data?.productCode) {
        // 查询到信息则直接加入
        props.add({
          ...detail.data,
          id: detail.data.productCode,
          productCode: detail.data.productCode,
          productType: 1
        })
        loading.value = false
        return
      }
    } else {
      // sku
      const detail: any = await searchProducts({
        channel: 2,
        channelList: [1, 2],
        keyword: keyword.value,
        langType: '1',
        pageNum: 1,
        pageSize: 50
      })
      if (detail.data?.records?.length === 1) {
        const product = detail.data.records[0]
        props.add({
          ...product,
          id: product.productCode,
          productCode: product.productCode,
          productType: 1
        })
        loading.value = false
        return
      }
    }
  }
  platformGoodsDrawer.value.open(isSearch ? keyword.value : '', langType.value, type)
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('供货商品')), 1),
            _createElementVNode("span", {
              class: "link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (platformGoodsDrawer.value.open('', '', 'oem')))
            }, _toDisplayString(_unref(t)('选择OEM、组合商品')) + ">", 1),
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('绑定成功后，多个供货商品之间的库存可共用！下单时会按照顺位进行依次扣除')), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createVNode(Search, {
            placeholder: _unref(t)('请输入URL、商品名、THE CKB SKU'),
            class: "search-platform",
            value: keyword.value,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((keyword).value = $event)),
            onSearch: _cache[3] || (_cache[3] = ($event: any) => (search('transparent', true, true))),
            loading: loading.value
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"130px"},
                modelValue: langType.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((langType).value = $event))
              }, {
                default: _withCtx(() => [
                  (_unref(isJA)())
                    ? (_openBlock(), _createBlock(_component_el_option, {
                        key: 0,
                        label: _unref(t)('日本语入力'),
                        value: "1"
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_unref(isEN)())
                    ? (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        label: "English",
                        value: "4"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('中国语入力'),
                    value: "2"
                  }, null, 8, ["label"]),
                  (_unref(isKO)())
                    ? (_openBlock(), _createBlock(_component_el_option, {
                        key: 2,
                        label: _unref(t)('韩语'),
                        value: "3"
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["placeholder", "value", "loading"])
        ])
      ]),
      _createVNode(_component_el_scrollbar, {
        always: true,
        style: {"flex":"1"},
        key: __props.keyIndex
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "scrollbar-flex-content",
            style: _normalizeStyle({ height: __props.height + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productList, (i, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "platform-goods-item"
              }, [
                _createVNode(PlatformGoodsItem, {
                  product: i,
                  index: index,
                  change: __props.change,
                  height: __props.height - 325,
                  onOpen: _cache[4] || (_cache[4] = ($event: any) => (search('transparent')))
                }, null, 8, ["product", "index", "change", "height"])
              ]))
            }), 128)),
            (__props.productList.length < 30)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(PlatformGoodsItem, {
                    onOpen: _cache[5] || (_cache[5] = ($event: any) => (search(__props.productList.length === 0 ? 'transparent' : 'stock'))),
                    height: __props.height - 325,
                    add: __props.add,
                    shopDetail: __props.shopDetail
                  }, null, 8, ["height", "add", "shopDetail"])
                ]))
              : _createCommentVNode("", true)
          ], 4)
        ]),
        _: 1
      })
    ]),
    _createVNode(PlatformGoodsDrawer, {
      ref: (_value, _refs) => {
        _refs['platformGoodsDrawer'] = _value
        platformGoodsDrawer.value = _value
      },
      add: __props.add
    }, null, 8, ["add"])
  ], 64))
}
}

})